export function generateRandomString(length: number = 10) {
    let result = '';
    while (result.length < length) {
        const rand = Math.random().toString(36).substring(2);
        result += rand;
    }
    return result.substring(0, length);
}

export function generateUID(timestamp?: number) {
    return (timestamp || Date.now()).toString(36).substring(2) + generateRandomString();
}